import React, { useRef, useEffect, useState } from "react";
import cn from "clsx";
import Img from "@/components/img";
import { isServer } from "@/util";
import useSwiperScriptLoader from "@/hooks/useSwiperScript";
import "./style.scss";

const StoreLocatorThumbSwiper = ({ selectedShop }) => {
  const mainSwiperRef = useRef(null);
  const bottomSwiperRef = useRef(null);
  const loadedScriptStatus = useSwiperScriptLoader();
  const [bottomSwiper, setBottomSwiper] = useState(null);

  useEffect(() => {
    if (
      mainSwiperRef.current &&
      bottomSwiperRef.current &&
      (loadedScriptStatus || window.Swiper)
    ) {
      const swiper = new window.Swiper(".bottom-swiper", {
        spaceBetween: 10,
        slidesPerView: 4,
        centeredSlides: true,
        watchSlidesProgress: true
      });
      const swiper2 = new window.Swiper(".main-swiper", {
        spaceBetween: 10,
        thumbs: {
          swiper: swiper
        }
      });
      setBottomSwiper(swiper);
    }
  }, [mainSwiperRef, bottomSwiperRef, loadedScriptStatus]);

  const onSlideClick = () => {
    bottomSwiper?.slideTo(bottomSwiper.clickedIndex);
  };

  const screenWidth = !isServer && document.body.clientWidth;
  let galleryImages = [];
  if (selectedShop.shopImageUrl) galleryImages = [selectedShop.shopImageUrl];
  if (selectedShop.galleryImages)
    galleryImages = [...galleryImages, ...selectedShop.galleryImages];

  return (
    <div>
      <div
        className="swiper main-swiper"
        style={{ marginBottom: "10px" }}
        ref={mainSwiperRef}
      >
        <div className="swiper-wrapper swiper-container store-locator-gallery-container">
          {galleryImages &&
            galleryImages.map((item, index) => (
              <span className="swiper-slide" key={index}>
                <Img src={`${item.img || item}`} alt="image" />
              </span>
            ))}
        </div>
      </div>
      <div className="swiper bottom-swiper" ref={bottomSwiperRef}>
        <div className="swiper-wrapper">
          {galleryImages &&
            galleryImages.map((item, index) => (
              <span
                className={cn("swiper-slide", {
                  active: index === bottomSwiper?.clickedIndex
                })}
                key={index}
                onClick={onSlideClick}
              >
                <Img
                  src={`${item.img || item}`}
                  alt={`gallery image ${index}`}
                />
              </span>
            ))}
        </div>
      </div>
    </div>
  );
};

export default StoreLocatorThumbSwiper;
